"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_rainbow_components_1 = require("react-rainbow-components");
var icons_1 = require("@rainbow-modules/icons");
var useReduxForm_1 = __importDefault(require("react-rainbow-components/libs/hooks/useReduxForm"));
var get_1 = __importDefault(require("lodash/get"));
var UniversalFormOverlay_1 = __importDefault(require("../UniversalFormOverlay"));
var overlayField_1 = __importDefault(require("./overlayField"));
var styled_1 = require("./styled");
var EditableCell = function (props) {
    var _a = useReduxForm_1.default(props), name = _a.name, row = _a.row, value = _a.value, index = _a.index, onChange = _a.onChange, isEditable = _a.isEditable, isEditableFunction = _a.isEditableFunction, Component = _a.columnComponent, validate = _a.columnValidate, type = _a.type, cellAlignment = _a.cellAlignment, dirty = _a.dirty;
    var containerRef = react_1.useRef();
    var _b = react_1.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var RenderedComponent = Component || (function () { return null; });
    var closeForm = function () {
        setIsOpen(false);
    };
    var handleSubmit = function (values) {
        closeForm();
        onChange(get_1.default(values, name));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styled_1.EditableContainer, { ref: containerRef, isDirty: dirty, cellAlignment: cellAlignment },
            react_1.default.createElement(react_rainbow_components_1.RenderIf, { isTrue: Component },
                react_1.default.createElement(RenderedComponent, { value: value, row: row, index: index, dirty: dirty })),
            react_1.default.createElement(react_rainbow_components_1.RenderIf, { isTrue: !Component }, value),
            react_1.default.createElement(react_rainbow_components_1.RenderIf, { isTrue: isEditable },
                react_1.default.createElement(styled_1.StyledButtonIcon, { cellAlignment: cellAlignment, icon: react_1.default.createElement(icons_1.Edit, null), onClick: function () { return setIsOpen(true); } })),
            react_1.default.createElement(react_rainbow_components_1.RenderIf, { isTrue: !isEditable && isEditableFunction },
                react_1.default.createElement(styled_1.StyledButtonIcon, { cellAlignment: cellAlignment, icon: react_1.default.createElement(icons_1.Lock, null), disabled: true }))),
        react_1.default.createElement(UniversalFormOverlay_1.default, { triggerElementRef: containerRef, isOpen: isOpen, fields: overlayField_1.default, onRequestClose: closeForm, onSumbit: handleSubmit, name: name, value: value, validate: validate, type: type })));
};
exports.default = EditableCell;
//# sourceMappingURL=editableCell.js.map